( function( app ) {
  const COMPONENT = {
    init: function() {
      const component = document.querySelector(
          '[data-component="instagram"]',
      );

      if ( ! component ) return;

      const track = component.querySelector( '#sbi_images' );

      if ( ! track ) return;

      component.style.overflow = 'hidden';

      let x = 0;
      let paused = false;
      let animationFrame;
      const speed = 0.75;

      const setup = () => {
        cancelAnimationFrame( animationFrame );

        track.style.transform = 'translate3d(0,0,0)';
        x = 0;

        track.querySelectorAll( '[aria-hidden="true"]' ).forEach( ( clone ) => {
          clone.remove();
        } );

        track.style.display = 'flex';
        track.style.flexWrap = 'nowrap';
        track.style.gap = '1rem';
        track.style.willChange = 'transform';

        [...track.children].forEach( ( item ) => {
          item.style.flex = '0 0 auto';
        } );

        const items = [
          ...track.querySelectorAll( '.sbi_item:not([aria-hidden="true"])' ),
        ];

        items.forEach( ( item ) => {
          const clone = item.cloneNode( true );

          clone.setAttribute( 'aria-hidden', 'true' );
          track.appendChild( clone );
        } );

        animate();
      };

      const animate = () => {
        if ( ! paused ) {
          x -= speed;
          const loopWidth = track.scrollWidth / 2;

          if ( Math.abs( x ) >= loopWidth ) {
            x = 0;
          }

          track.style.transform = `translate3d(${x}px,0,0)`;
        }

        animationFrame = requestAnimationFrame( animate );
      };

      track.addEventListener( 'mouseenter', () => {
        paused = true;
      } );

      track.addEventListener( 'mouseleave', () => {
        paused = false;
      } );

      let resizeTimeout;

      window.addEventListener( 'resize', () => {
        clearTimeout( resizeTimeout );

        resizeTimeout = setTimeout( () => {
          setup();
        }, 150 );
      } );

      setup();
    },
    finalize: function() {
    },
  };
  app.registerComponent( 'instagram', COMPONENT );
} )( app );
